import { Component, Vue, Watch } from 'vue-property-decorator';
import WithRender from './App.html';
import UserService from '@/shared/userService/UserService';
import { Inject } from 'vue-di-container';
import './App.scss';
import { getThemeColor, updateAppVariables } from './appTheme';

@WithRender
@Component({
  diProvide: [UserService],
})
export default class App extends Vue {
  @Inject(UserService) public userService!: UserService;

  public breadcrumbList: any = [];

  public async mounted() {
    this.updateUIFrameWork();
    updateAppVariables();

    this.onRouteChange();
  }

  @Watch('$route')
  public onRouteChange(): any {
    this.breadcrumbList = [];
    if (this.$route.meta && this.$route.meta.breadcrumb) {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    }
  }

  public routeTo(pRouteTo: number) {
    if (this.breadcrumbList[pRouteTo].link) {
      this.$router.push(this.breadcrumbList[pRouteTo].link);
    }
  }

  public updateUIFrameWork() {
    const { primary, secondary } = this.$vuetify.theme.themes.light;

    const lightTheme = this.$vuetify.theme.themes.light;
    lightTheme.primary = getThemeColor('primary') || primary;
    lightTheme.secondary = getThemeColor('secondary') || secondary;
  }
}
